<script setup lang="ts">
import { SingleSelectList, SingleSelectListItem } from '@laam/ui/base';
import { BrandsPageSortBy } from '~/utils/enums';
const { $eventClient } = useNuxtApp();
const updateSortOption = inject('updateSortOption') as (value: string) => void;
interface SortList {
	sortOptionSelected: string;
}
defineProps<SortList>();
const emits = defineEmits(['update']);
const handleClick = (value: string) => {
	updateSortOption(value);
	emits('update');
	$eventClient.sendEvent('brands-sort-option-clicked', {
		sortOption: value,
	});
};
</script>
<template>
	<SingleSelectList>
		<SingleSelectListItem
			v-for="(value, key) in BrandsPageSortBy"
			:key="key"
			:value="value"
			:selected="sortOptionSelected === value"
			class="!px-0 w-full"
			@click="handleClick(value)"
		>
			<div class="flex items-center gap-3xl w-full justify-between">
				{{ key }}
				<div v-if="sortOptionSelected === value">
					<div
						class="bg-black w-5xl h-5xl rounded-full cursor-default flex items-center justify-center"
					>
						<div class="w-md h-md rounded-full bg-white"></div>
					</div>
				</div>
				<div
					v-else
					class="appearance-none bg-white w-5xl h-5xl rounded-full border border-solid border-gray-300 cursor-default flex items-center justify-center hover:cursor-pointer"
				></div>
			</div>
		</SingleSelectListItem>
	</SingleSelectList>
</template>
